export interface IFacet {
  facet: string;
  options: {
    count: number;
    label: string;
    value: string;
  }[];
}

export interface IMatchingSearchState {
  loading: boolean;
  loadingFacet: boolean;
  error: string | null;
  results: any[];
  facets: {
    founding_date: IFacet;
    sectors: IFacet;
    countries: IFacet;
    regions: IFacet;
  };
  hit_count: number;
  page: number;
  per_page: number;
  filters: {
    vil: number[];
    countries: string[];
    sectors: string[];
    query: string;
    sort: "asc" | "desc";
    founding_date: number[];
    action: "search" | "scroll";
    sectorsFacetQuery: string;
    countriesFacetQuery: string;
    foundingDateFacetQuery: string;
  };
}

export enum EMatchingSearchState {
  NAMESPACE = "matchingSearch",
}

export enum EMatchingSearchActions {
  SEARCH = "matchingSearch/search",
  LOAD_FACETS = "matchingSearch/loadFacets",
  SET_FILTERS = "matchingSearch/setFilters",
  SEARCH_FILTERS = "matchingSearch/searchFilters",
}

export enum EMatchingSearchMutations {
  SET_LOADING = "setLoading",
  SET_ERROR = "setError",
  SET_RESULTS = "setResults",
  SET_FACETS = "setFacets",
  SET_FILTERS = "setFilters",
  SET_LOADING_FACET = "setLoadingFacet",
}

export enum EMatchingSearchGetters {
  RESULTS = "matchingSearch/results",
  FACETS = "matchingSearch/facets",
}
